// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSelectedPostingDate = newPostingDate => ({
    payload: newPostingDate,
    type: actions.UPDATE_REIMBURSEMENT_SUMMARY_SELECTED_POSTING_DATE
});



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/selected-posting-date.js